import {
  CRYPTO_DISPLAY_DECIMALS,
  formatBrlFromString,
  formatCryptoAmount,
} from "../../../Services/stablesMoney";

export const QUOTE_DURATION_SEC = 8;

export const QUOTE_TITLES = {
  buy: "Cotação de compra",
  sell: "Cotação de venda",
  swap: "Cotação de swap",
  withdraw: "Confirmar saque",
};

/** USDT/USDC quantities — 6 fixed decimals, dot separator (e.g. 1000.000000). */
export const formatQuoteCrypto = (value) =>
  formatCryptoAmount(value, CRYPTO_DISPLAY_DECIMALS);

/** BRL amounts — Brazilian format with comma decimal. */
export const formatQuoteBrl = (value, decimals = 2) => {
  const numericValue = Number(value);
  const safeValue = Number.isFinite(numericValue) ? numericValue : 0;
  return formatBrlFromString(safeValue.toFixed(decimals), decimals);
};

/** Unit price in BRL — 4 decimals, Brazilian format. */
export const formatQuotePrice = (value, decimals = 4) =>
  formatBrlFromString(String(value ?? ""), decimals);

export const formatQuotePercent = (value) => formatQuoteBrl(value, 2);

/** @deprecated Prefer formatQuoteCrypto, formatQuoteBrl, or formatQuotePrice. */
export const formatQuoteValue = (value, decimals = 4) => {
  if (decimals === CRYPTO_DISPLAY_DECIMALS) {
    return formatQuoteCrypto(value);
  }

  const numericValue = Number(value);
  const safeValue = Number.isFinite(numericValue) ? numericValue : 0;
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(safeValue);
};

export const formatQuoteTimer = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
};
